import { createAction } from '@reduxjs/toolkit'
import { IWalletInfo, WalletStateEnum } from './types'

export const updateWalletStatus = createAction<{ walletInfo: IWalletInfo | null }>('wallet/updateWalletStatus')

export const setWalletState = createAction<{ walletState: WalletStateEnum }>('wallet/setWalletState')
export const setSelectedWalletName = createAction<string>('wallet/setSelectedWalletName')
export const setSelectedChainId= createAction<number>('wallet/setSelectedChainId')
export const setSolanaConnected= createAction<boolean>('wallet/setSolanaConnected')